import * as React from 'react';
import { useState, useEffect } from 'react';
import { Button, Box } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import HomeMobile from './Pictures/HomeMobile.png';
import HomeDesk from './Pictures/HomeDesk.png';
import Home01Mobile from './Pictures/Home01Mobile.png';
import Home01Desk from './Pictures/Home01Desk.png';
import Home02Desk from './Pictures/Home02Desk.png';
import Home02Mobile from './Pictures/Home02Mobile.png';
import Home03Desk from './Pictures/Home03Desk.png';
import Home03Mobile from './Pictures/Home03Mobile.png';
import Dr01 from './Pictures/DrDeepanwita.png';
import Dr02 from './Pictures/DrAnkita.png';
import Dr01Desk from './Pictures/DrDeepanwitaDesk.png'
import Dr02Desk from './Pictures/DrAnkitaDesk.png'
import BestClinic from './Pictures/BestClinic.png';
import Appointment from './Appointment';
import ReactModal from 'react-modal';
import './Home.css'; // Make sure to update the CSS file
import ScrollCardComp from './ScrollCardComp';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import DoctorCarousel from './DoctorCarousel';

export default function Home() {
  const [seen, setSeen] = useState(false);
  const [appoinmentFormVisible, SetAppoinmentFormVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  const checkDeviceType = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    checkDeviceType();
    window.addEventListener('resize', checkDeviceType);
    return () => {
      window.removeEventListener('resize', checkDeviceType);
    };
  }, []);

  const onAppoinmentHandler = () => {
    if (isMobile) {
      navigate('/ContactUs');
      setTimeout(() => {
        const section = document.getElementById('specific-section');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    } else {
      SetAppoinmentFormVisible(true);
    }
  };

  return (
    <div className="home-container">
      {/* Carousel Section */}
      <div id="carouselExampleInterval" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={isMobile ? HomeMobile : HomeDesk} className="d-block w-100 carousel-img" alt="Home" />
          </div>
          <div className="carousel-item">
            <img src={isMobile ? Home01Mobile : Home01Desk} className="d-block w-100 carousel-img" alt="Home 1" />
          </div>
          <div className="carousel-item">
            <img src={isMobile ? Home02Mobile : Home02Desk} className="d-block w-100 carousel-img" alt="Home 2" />
          </div>
          <div className="carousel-item">
            <img src={isMobile ? Home03Mobile : Home03Desk} className="d-block w-100 carousel-img" alt="Home 3" />
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
        </button>
      </div>

      {/* Best Dental Clinic Section - Modern Design */}
      <section className="best-clinic">
        <div className="container">
          <h1 className="section-title text-center">Best Dental Clinic in Hyderabad</h1>
          <div className="row row-cols-1 row-cols-md-2 g-4">
            <div className="col">
              <div className="clinic-img-container">
                <img src={BestClinic} className="d-block w-100 clinic-img" alt="Best Clinic" />
              </div>
            </div>
            <div className="col">
              <div className="clinic-info">
                <p>
                  At Aarogyam Dental Care, we are committed to providing quality dental care tailored to your needs in Hyderabad.
                  Our mission is to offer a comprehensive range of dental services in a comfortable and welcoming setting,
                  ensuring a positive experience with every visit. Whether you require a regular dental check-up, professional
                  teeth cleaning, or more advanced procedures such as dental implants, root canal treatment, teeth whitening,
                  orthodontics (braces/aligners), or cosmetic dentistry, our highly skilled and experienced team of dentists is
                  dedicated to helping you achieve and maintain a healthy and radiant smile. We blend modern dental technology with
                  a compassionate approach to deliver the best possible treatment. Aarogyam Dental Care offers a wide array of dental
                  treatments focused on enhancing your oral health, improving dental aesthetics, and promoting overall wellness. Equipped
                  with advanced technology and an experienced dental team, we are a preferred choice for quality dental care in Hyderabad
                  and surrounding areas.
                </p><Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
                  <Button
                    size="large"
                    onClick={onAppoinmentHandler}
                    variant="contained"
                    style={{ background: '#2E073F' }}
                  >
                    Make An Appointment
                  </Button>
                </Box>
                <ReactModal isOpen={appoinmentFormVisible} onRequestClose={() => SetAppoinmentFormVisible(false)} style={{
                  overlay: {
                    background: "rgba(0, 0, 0, 0.8)"
                  },
                  content: {
                    width: "500px",
                    height: "520px",
                    position: 'absolute',
                    top: 150,
                    left: 550

                  }
                }}>
                  <Appointment />
                </ReactModal>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Meet Our Doctors Section */}
      <section className="doctors">
        <div className="container text-center">
          <h1 className="section-title">Meet Our Doctors</h1>
          <DoctorCarousel />
        </div>
      </section>

      {/* Scroll Cards Section */}
      <div className="container text-center">
        <ScrollCardComp />
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
